import { render } from "./LoadingIndicator.vue?vue&type=template&id=0a0f223a&scoped=true"
import script from "./LoadingIndicator.vue?vue&type=script&lang=js"
export * from "./LoadingIndicator.vue?vue&type=script&lang=js"

import "./LoadingIndicator.vue?vue&type=style&index=0&id=0a0f223a&scoped=true&lang=css"

import exportComponent from "/home/melvin/Workspace/Sjef.app/frontend/pos.sjef.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a0f223a"]])

export default __exports__